module.exports = __webpack_public_path__ + "static/media/camilla_chan.006a8334.png";